import type { ReactNode } from 'react';

export const symbol_2d_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M377-282H187q-11 0-18-7t-7-18v-29q0-5 2-10t7-9q47-37 78.5-62t51.5-49q19-22 29-42t10-43q0-33-19-53.5T275-625q-20 0-34.5 12.5T219-583q-5 11-15 15t-21 0q-12-4-17-15.5t-2-24.5q9-38 42-57t70-19q60 0 92 29.5t32 86.5q0 38-15 71t-38 63q-23 30-51 51t-58 42h139q12 0 21 9t9 21q0 12-9 20.5t-21 8.5Zm135 0q-13 0-21.5-8.5T482-312v-334q0-13 8.5-21.5T512-676h101q91 0 139.5 51.5T801-479q0 94-49.5 145.5T613-282H512Zm30-60h70q66 0 98-33.5T742-479q0-70-32-103.5T612-616h-70v274Z"
		/>
	</svg>
);
